/*
 *  webtool下载相关
 */
import * as Util from 'js/util/util.js'
import Cookie from 'js-cookie'
const { getData } = require('js/api/getdata').default

// 是否有客户端权限
async function isClientAuth() {
  let clientAuth = await getData('clientAccess')
  let list = clientAuth.data.device_download_list.filter((item) => {
    return item.device === 'window' || item.device === 'mac'
  })
  return list[0].status === 'enable' || list[1].status === 'enable'
}

/**
 *是否有webtool外链权限
 * @param {*} delivery_code 外链id
 */
async function check_webtool_auth(delivery_code) {
  return !Util.isSafari()
}

/**
 *单文件下载弹窗
 * @param {string} type link = 外链 preview = 预览
 * @param {Array} data  下载的数据
 * @param {*} continueCb 点继续的callback
 */
async function webtool_single_dialog(type, data, continueCb) {
  let webtoolAuth = false
  if (type === 'link') {
    webtoolAuth = await check_webtool_auth(data[0].delivery_code)
    if(webtoolAuth){
      if(data[0].eodDownloadUrl){
        let result = await webtool_single_eod(data)
        if(!result) {
          return false
        }
      }
      webtoolDownload(type, data)
      return true
    }
  } else if (type === 'preview') {
    webtoolAuth = !Util.isSafari()
  }
  if (!webtoolAuth) {
    continueCb && continueCb()
    return
  }
  $confirm.show({
    value: true,
    isShow: true,
    onlyOne: false,
    title: '提示',
    sureBtn: '通过WebTool下载',
    content: '当前文件过大，建议使用WebTool下载，更稳定，更快速',
    extraBtn: '',
    continueObj: {
      text: '继续下载',
      show: true,
    },
    sure() {
      $confirm.show({ rightIcon: '#loading' }) // 点确定loading
      webtoolDownload(type, data)
    },
    toContinue() {
      continueCb && continueCb()
      $confirm.hide()
    },
  })
}

async function webtool_single_eod(data) {
  if (data[0].eodDownloadUrl) {
    const result = await getEodUrl(urlEncode(data[0].eodDownloadUrl)) // eod下载地址
    if (result.data.type === 'success') {
      return true
    } else {
      window.$toast.simpleShow(result.data.message, 'warn')
      return false
    }
  }
}

function urlEncode(url) {
  let param = ''
  let baseUrl = url
  if (url.indexOf('?') > -1) {
    const arr = url.split('?')
    param = arr[1]
    baseUrl = arr[0]
  }
  const index = baseUrl.indexOf('/delivery')
  const encodeUrl = encodeURIComponent(baseUrl.slice(index))
  const frontUrl = baseUrl.substring(index, -index)
  return `${frontUrl + encodeUrl}?${param}`
}

/**
 *打包下载弹窗
 * @param {string} type link = 外链 preview = 预览
 * @param {object} shareInfo  外链信息
 * @param {Array} data  下载的数据
 * @param {*} result 接口
 */
async function webtool_multi_dialog(type, shareInfo, data, result) {
  let clientAuth = await isClientAuth() // 客户端权限
  let webtoolAuth = await check_webtool_auth(data[0].delivery_code) // webtool权限
  let code = result.file_limit_code
  let content
  let onlyOne
  let sureBtn
  let sure
  if (!webtoolAuth) {
    // 没有webtool权限，safari不支持视为无权限
    switch (code) {
      case 'total_file_num_limit':
        content = clientAuth
          ? '文件总数超过200条，请分批下载或通过电脑客户端下载'
          : '文件总数超过200条，请分批下载'
        break
      case 'total_file_size_limit':
        content = clientAuth
          ? '文件总大小超过5GB，请分批下载或通过电脑客户端下载'
          : '文件总大小超过5GB，请分批下载'
        break
    }
    onlyOne = true
    sureBtn = '确认'
    sure = () => $confirm.hide()
  } else {
    switch (code) {
      case 'total_file_num_limit':
        content = '文件总数超过200条，请分批下载或通过WebTool下载'
        break
      case 'total_file_size_limit':
        content = '文件总大小超过5GB，请分批下载或通过WebTool下载'
        break
    }
    onlyOne = false
    sureBtn = '通过WebTool下载'
    sure = async () => {
      if(shareInfo.isSecurity) {
        const result = await webtool_multi_eod(shareInfo,data)
        if(!result) {
          $confirm.hide()
          return false
        }
      }
      $confirm.hide()
      webtoolDownload(type, data)
    }
  }
  $confirm.show({
    title: '提示',
    value: true,
    isShow: true,
    extraBtn: '',
    onlyOne,
    sureBtn,
    content,
    sure,
  })
}

async function webtool_multi_eod(shareInfo,data) {
  let neids = ''
  data.forEach((value) => {
    neids += `neids=${value.neid}&`
  })
  neids = neids.substr(0, neids.length - 1)
  let result = {}
  if (shareInfo.isProtected) {
    result = await getEodUrl(`${data[0].download_url}&${neids}`)
  } else {
    result = await getEodUrl(`${data[0].download_url}?${neids}`)
  }

  if (result.data.type === 'success') {
    return true
  } else {
    $toast.simpleShow(result.data.message, 'warn')
    return false
  }
}

async function getEodUrl(url) {
  return new Promise((resolve, reject) => {
    getData(url).then((res) => {
      resolve(res)
    }).catch((error) => {
      resolve(error.response)
    })
  })
}

/**
 * 外链下载方法
 * @param {Object} metadata info 信息isShowPath
 * @param {string} metadata.user_info 外链信息
 * @param {boolean} metadata.isShowTrans 外链信息
 * @param {boolean} metadata.isShowPath 外链信息
 * @param {Object} metadata.delivery_info 外链信息
 * @param {string} metadata.delivery_info.delivery_code  外链的code码
 * @param {string} metadata.delivery_info.LBC 数据中心标记
 * @param {string} metadata.delivery_info.token 带密码的外链需要的验证码
 * @param {Array} metadata.delivery_info.metadata 为数组，内容为外链的meta信息，不一定完整的metadata，至少提供下载的必须项path、is_dir、rev
 * * */
function transferData(data) {
  let $data = data.map((item) => {
    const { bytes, is_dir, path, neid, nsid, rev = '' } = item
    return { bytes, is_dir, path, neid, nsid, rev }
  })
  let query = Util.queryString('?' + data[0].download_url.split('?')[1])
  let local_path = ''
  let isShowTrans = true
  let isShowPath = true
  let host = window.location.origin
  let delivery_info = {
    LBC: query.lbc || '',
    token: query.token || '',
    delivery_code: data[0].delivery_code || '',
    metadata: $data,
  }
  let user_info = {
    S: 'SSymbol',
    user_id: window.store.getters.uId || '',
    'X-LENOVO-SESS-ID': Cookie.get('X-LENOVO-SESS-ID') || query['x-lenovo-sess-id'] || '',
  }
  return {
    delivery_info,
    user_info,
    isShowTrans,
    isShowPath,
    local_path,
    host,
  }
}

/**
 *webtool下载
 * @param {string} type link = 外链 preview = 预览
 * @param {Array} data  下载的数据
 */
function webtoolDownload(type, data) {
  if (type === 'preview') {
    window.$bsWebTool.downloadCore(
      {
        metadata: data,
        isShowPath: true,
        isShowTrans: true,
      },
      () => {
        $confirm.hide()
      },
    )
  } else if (type === 'link') {
    let _data = transferData(data)
    console.log(_data)
    window.$bsWebTool.deliveryDownload(_data, () => {
      $confirm.hide()
    })
  }
}
export { check_webtool_auth, webtool_single_dialog, webtool_multi_dialog }
